// src/components/ReportContainer.js
import React, { useState, useEffect } from 'react';
import { PowerBIEmbed } from 'powerbi-client-react';
import { models } from 'powerbi-client';

const ReportContainer = ({ reportName, userReports }) => {
  const [embedConfig, setEmbedConfig] = useState({
    type: 'report',
    embedUrl: '',
    accessToken: '',
    tokenType: models.TokenType.Embed,
    settings: {
      panes: {
        filters: {
          visible: false
        }
      },
      layoutType: models.LayoutType.MasterOnlyLayout
    }
  });

  useEffect(() => {
    if (reportName) {
      loadReport(reportName);
    }
  }, [reportName, userReports]);

  const loadReport = (reportName) => {
    console.log(`Requesting report: ${reportName}`);
    fetch(`https://dml-portal-functions.azurewebsites.net/api/report?reportName=${reportName}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-User-Reports': JSON.stringify(userReports)
      }
    })
    .then(response => {
      if (!response.ok) {
        if (response.status === 403) {
          console.log('Permission denied for report:', reportName);
          alert('You do not have permission to view this report.');
        } else {
          console.error('Network response was not ok');
        }
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(data => {
      console.log('Report response:', data);
      if (data) {
        setEmbedConfig(prevConfig => ({
          ...prevConfig,
          embedUrl: data.embedUrl,
          accessToken: data.embedToken
        }));
        console.log('Embed config updated for report:', reportName);
      }
    })
    .catch(error => {
      console.error('Error during report load:', error);
      console.log('Failed to load report:', reportName);
      alert('Failed to load report');
    });
  };

  const eventHandlers = new Map([
    ['loaded', function () { console.log('Report loaded'); }],
    ['rendered', function () { console.log('Report rendered'); }],
    ['error', function (event) { console.log(event.detail); }]
  ]);

  return (
    <div className="w-full h-full" style={{ aspectRatio: '16/9' }}>
      <PowerBIEmbed
        embedConfig={embedConfig}
        eventHandlers={eventHandlers}
        cssClassName="w-full h-full"
        getEmbeddedComponent={(embeddedReport) => {
          window.report = embeddedReport;
        }}
      />
    </div>
  );
};

export default ReportContainer;
